<template>
  <div
    class="col-12"
    style="line-height: 22px;">
    <div class="text-center">
      <h2>Lancaster Dropship Policy</h2>
      <div>
        <small class="text-muted">
          Thank you for placing a dropship order with Lancaster. To ensure transparency and a smooth experience, please review the following policies carefully.
        </small>
      </div>
    </div>
    <div class="mt-4">
      <strong>General Terms</strong>
      <ul>
        <li>
          <strong>All Dropship Sales Are Final:</strong> Lancaster does not accept returns on dropship orders.
        </li>  
        <li>
          <strong>Damaged Shipments:</strong> If your order arrives damaged, refuse the delivery, take clear photos of the damage, and document the shipment condition. Contact us immediately at <a href="mailto: dropship@lancasterco.com">dropship@lancasterco.com</a> to initiate a resolution.
        </li>  
        <li>
          <strong>Credit:</strong> You must be in good credit standing in order to place a dropship.
        </li>  
      </ul>
    </div>
    <div>
      <strong>Order Changes and Cancellations</strong>
      <ul>
        <li>
          <strong>Order Cancellations:</strong> If you need to cancel your order, contact us as soon as possible. If the order has already shipped, cancellation may not be possible and/or a partial credit may be offered. Lancaster is subject to each manufacturer’s policies.
        </li>
        <li>
          <strong>Shipping Addresses:</strong> Dropship orders can only be shipped to the address listed on your account. Alternate shipping addresses will not be accepted.
        </li>
        <li>
          <strong>Responsibility:</strong> It is your responsibility to review order confirmations and notify Lancaster immediately of any discrepancies.
        </li>
      </ul>
    </div>
    <div>
      <strong>Shipping and Manufacturer Details</strong>
      <ul>
        <li>
          <strong>Processing Times:</strong> Lancaster is not responsible for manufacturer processing timelines. Typical delivery is within 2–3 weeks, but this may vary. For order status updates, please contact <a href="mailto: dropship@lancasterco.com">dropship@lancasterco.com</a>
        </li>
        <li>
          <strong>Minimum and Prepaid Thresholds:</strong> Be aware that each manufacturer has different order minimums and prepaid freight thresholds. These are displayed at the top of each product page.
        </li>
      </ul>
    </div>
    <div>
      <strong>Suspended or Discontinued Items</strong>
      <ul>
        <li>Some items may be suspended or discontinued without notice. In such cases, Lancaster will notify you with any available alternatives or expected restock dates.</li>
      </ul>
    </div>
    <div>
      <strong>Additional Drop Ship Information</strong>
      <ul>
        <li>
          For all other requests / inquires into dropship products please email:
          <a href="mailto:dropship@lancasterco.com">dropship@lancasterco.com</a>
        </li>
      </ul>
    </div>
  </div>
</template>